import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import "./styles.css"
import { startGame, viewGroupMap } from "./game"
import type { SessionUser } from "./auth/AuthGate"
import "./posthog"

const rootEl = document.getElementById("root")!
const reactRoot = createRoot(rootEl)

// React.StrictMode double-invokes effects in dev, which can call these handlers twice.
// Both create a whole Engine/GameScene (canvases, SSE connections, module-singleton UI
// hooks) — a second call must be a no-op, not a second game instance.
let gameStarted = false

function handleStartGame(user: SessionUser): void {
  if (gameStarted) return
  gameStarted = true
  reactRoot.unmount()
  rootEl.remove()
  void startGame(user)
}

function handleViewGroupMap(groupId: string, groupName: string): void {
  if (gameStarted) return
  gameStarted = true
  reactRoot.unmount()
  rootEl.remove()
  void viewGroupMap(groupId, groupName)
}

reactRoot.render(
  <React.StrictMode>
    <App onStartGame={handleStartGame} onViewGroupMap={handleViewGroupMap} />
  </React.StrictMode>,
)
